import {inject, Injectable} from "@angular/core";
import {OverviewRepo} from "../api/overview.repo";
import {OrgDto} from "../dto/org.dto";
import {Observable} from "rxjs";
import {WrapperDto} from "../dto/wrapper.dto";
import {OverviewDto} from "../dto/overview-dto";
import {isDefined} from "../../libs/utils/epic.utils";
import {DuckDbHelper} from "./duckdb.helper";
import {map} from "rxjs/operators";

@Injectable({providedIn: 'root'})
export class OverviewDuckDb extends OverviewRepo {

  private overview: OverviewDto | undefined;

  private readonly duck = inject(DuckDbHelper);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public override getByOrg(_org: OrgDto): Observable<WrapperDto<OverviewDto>> {
    if (isDefined(this.overview)) {
      return DuckDbHelper.dataObs('OverviewDto', this.overview);
    }

    return this.duck.sql('SELECT * FROM overview').pipe(map((res) => {
      this.overview = this.buildOverview(res);
      return DuckDbHelper.data('OrgUserDto', this.overview);
    }));
  }

  private buildOverview(data: any): OverviewDto {
    const overview: any = {};
    for (const idx in data) {
      const row = data[idx];
      switch (row.type) {
        case 'INVOICE_ORDER':
          overview.invoiceOrderCount = row.counter;
          break;
        case 'INVOICE_UNPAID':
          overview.invoiceUnpaidCount = row.counter;
          break;
        case 'CONTACT_TOTAL':
          overview.contactCount = row.counter;
          break;
        case 'CONTACT_DEBTOR_TOTAL':
          overview.contactDebtorCount = row.counter;
          break;
        case 'CONTACT_CREDITOR_TOTAL':
          overview.contactCreditorCount = row.counter;
          break;
        case 'CONTACT_VEHICLE_TOTAL':
          overview.contactVehicleCount = row.counter;
          break;
        case 'ARTICLE_TOTAL':
          overview.articleCount = row.counter;
          break;
        case 'RECEIPT_TOTAL':
          overview.receiptCount = row.counter;
          break;
        case 'RECEIPT_UNREVIEWED':
          overview.receiptUnreviewedCount = row.counter;
          break;
        case 'RECEIPT_UNPAID':
          overview.receiptUnpaidCount = row.counter;
          break;
        case 'SHEET_TOTAL':
          overview.sheetCount = row.counter;
          break;
      }
    }
    return new OverviewDto(overview);
  }
}
